/**
 *
 * @param event An keyboard event.
 * @returns A boolean representing if the key
 * active in the interaction (event) is control or meta (mac)
 */
export function isCommandOrCtrlKeyActive(event: KeyboardEvent): boolean {
  const isMac = /^Mac/.test(window.navigator.platform)
  return isMac ? event.metaKey : event.ctrlKey
}
